import { useContext } from 'react';

import transactionContext from '@/contexts/transactionContext';
import { TransactionContext } from '@/types/transactions';

const useTransaction: () => TransactionContext | null = () => useContext(transactionContext);

export default useTransaction;
